var _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 9,
  r: 6.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.3259 11.2223C11.719 10.6339 11.9482 9.95313 11.9922 9.24985C12.0008 9.11205 11.8881 9 11.75 9H8.25C8.11193 9 8 8.88807 8 8.75L8 5.25C8 5.11193 7.88795 4.99919 7.75015 5.00781C7.04687 5.05182 6.36607 5.281 5.77772 5.67412C5.11992 6.11365 4.60723 6.73836 4.30448 7.46927C4.00173 8.20017 3.92252 9.00444 4.07686 9.78036C4.2312 10.5563 4.61216 11.269 5.17157 11.8284C5.73098 12.3878 6.44371 12.7688 7.21964 12.9231C7.99556 13.0775 8.79983 12.9983 9.53073 12.6955C10.2616 12.3928 10.8864 11.8801 11.3259 11.2223Z",
  stroke: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7.25,
  y: 1,
  width: 1.5,
  height: 2,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  width: 5,
  height: 1,
  rx: 0.5,
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/timer.78aba67aed09058a0d82f8f26dd1ac0f.svg";